/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIKeyMetadata } from './APIKeyMetadata';
import {
    APIKeyMetadataFromJSON,
    APIKeyMetadataFromJSONTyped,
    APIKeyMetadataToJSON,
    APIKeyMetadataToJSONTyped,
} from './APIKeyMetadata';

/**
 *
 * @export
 * @interface APIKeyCreated
 */
export interface APIKeyCreated {
    /**
     *
     * @type {boolean}
     * @memberof APIKeyCreated
     */
    readonly success: boolean;
    /**
     *
     * @type {string}
     * @memberof APIKeyCreated
     */
    readonly message: string;
    /**
     *
     * @type {APIKeyMetadata}
     * @memberof APIKeyCreated
     */
    readonly apiKey: APIKeyMetadata;
    /**
     *
     * @type {string}
     * @memberof APIKeyCreated
     */
    readonly key: string;
}

/**
 * Check if a given object implements the APIKeyCreated interface.
 */
export function instanceOfAPIKeyCreated(value: object): value is APIKeyCreated {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('apiKey' in value) || value['apiKey'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function APIKeyCreatedFromJSON(json: any): APIKeyCreated {
    return APIKeyCreatedFromJSONTyped(json, false);
}

export function APIKeyCreatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIKeyCreated {
    if (json == null) {
        return json;
    }
    return {

        'success': json['success'],
        'message': json['message'],
        'apiKey': APIKeyMetadataFromJSON(json['api_key']),
        'key': json['key'],
    };
}

  export function APIKeyCreatedToJSON(json: any): APIKeyCreated {
      return APIKeyCreatedToJSONTyped(json, false);
  }

  export function APIKeyCreatedToJSONTyped(value?: Omit<APIKeyCreated, 'success'|'message'|'api_key'|'key'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
